package io.horion.cv.api.datasource.cv

import kotlinx.serialization.Serializable

@Serializable
data class Learn(
    val label: String,
    val started: String,
    val ended: String,
    val description: String,
)